import * as React from "react";
import MultiSelect, { type Option } from "./multiple-selector";

export function MultipleSelectorBasicDemo() {
  const frameworks = [
    { label: "Next.js", value: "nextjs" },
    { label: "React", value: "react" },
    { label: "Vue", value: "vue" },
    { label: "Angular", value: "angular" },
    { label: "Svelte", value: "svelte" },
  ];

  return (
    <div className="max-w-sm">
      <MultiSelect
        placeholder="Select frameworks..."
        defaultOptions={frameworks}
      />
    </div>
  );
}
